/* eslint-disable max-len */
import { memo } from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import { SYSTEM_PATH } from '../../../../../../core/configs/constants';
import LinkButton from '../../../../../../components/Buttons/LinkButton/LinkButton';

import './style.scss';

const Courses = observer(({ data }) => {
    // const
    const imageBooks = data?.image || [];
    const buttonName = data?.buttonName || '';
    const tag = data?.tag || '';

    const isShowData = (Array.isArray(imageBooks) && imageBooks?.length > 0) ||
        (Array.isArray(data?.content) && data?.content?.length > 0);


    return isShowData ? (
        <div className='courses-box'>
            {/* Content text and button */}
            <div className='courses-content'>
                <div className='courses-list'>
                    {
                        Array.isArray(data?.content) &&
                        data?.content?.length > 0 &&
                        data?.content?.map((item, index) => (
                            <div key={index} className='courses-item'>
                                <IconCheck className='courses-item-icon' />
                                <div className='courses-item-text'>{item}</div>
                            </div>
                        ))
                    }
                </div>
                {buttonName && (
                    <LinkButton href={SYSTEM_PATH.THEMES} >{buttonName}</LinkButton>
                )}
            </div>

            {/* Books img and tag */}
            {Array.isArray(imageBooks) && imageBooks?.length > 0 && (
                <div>
                    <div className='courses-img'>
                        <div className='book-list'>
                            {imageBooks?.map((img, index) => (
                                <div key={index} className={`book-img book-${index + 1}`}>
                                    <img src={img.url || '/images/img-1.png'} alt='' className='book-img-element' />
                                </div>
                            ))}
                        </div>

                        {data?.tag && (
                            <>
                                <div className='tag' style={{ whiteSpace: 'pre-wrap' }}>
                                    <div className='tab-wrapper' >
                                        <div className='tab-content'>{tag}</div>
                                        <img className='tag-dot' src='/images/yellow-polka-dots.svg' />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}

        </div>
    ) : (<></>)
})

export default memo(Courses);

const IconCheck = ({ className = '' }) => {
    return (
        <svg
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={classNames(className)}
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 15C0 17.9667 0.879733 20.867 2.52795 23.3337C4.17618 25.8005 6.51887 27.7231 9.25977 28.8584C12.0007 29.9937 15.0166 30.2907 17.9264 29.7119C20.8361 29.1331 23.5088 27.7045 25.6066 25.6067C27.7044 23.5089 29.133 20.8362 29.7118 17.9265C30.2906 15.0168 29.9935 12.0007 28.8582 9.25977C27.7229 6.51887 25.8003 4.1763 23.3336 2.52808C20.8668 0.879855 17.9667 0 15 0C11.0274 0.0184101 7.22282 1.60475 4.41376 4.41382C1.60469 7.22288 0.0184101 11.0274 0 15ZM2.25 15C2.25 12.4704 3.00013 9.99759 4.40552 7.89429C5.8109 5.79098 7.80841 4.15164 10.1455 3.18359C12.4825 2.21555 15.0542 1.96231 17.5352 2.45581C20.0162 2.94932 22.2952 4.16759 24.0839 5.9563C25.8726 7.74501 27.0908 10.0239 27.5843 12.5049C28.0778 14.9859 27.8245 17.5575 26.8564 19.8945C25.8884 22.2316 24.2491 24.2291 22.1458 25.6345C20.0424 27.0399 17.5696 27.79 15.04 27.79C13.3597 27.7927 11.6953 27.4636 10.1424 26.8218C8.58942 26.18 7.17842 25.238 5.99023 24.0498C4.80205 22.8616 3.86006 21.4506 3.21823 19.8977C2.57641 18.3448 2.24737 16.6803 2.25 15ZM7.82001 15L13.82 21L22.82 12L21.16 10.49L13.79 17.8601L9.42999 13.3501L7.82001 15Z"
                fill="#4EA953"
            />
        </svg>
    )
}
